@if (playerRestrictions) {
  <div class="background">
    <table class="restrictions-table">
      <thead>
        <tr>
          @for (column of restrictionColumns; track column) {
            <th>
              <div class="restriction-column">
                {{ column.label }}
                @if (column.hint) {
                  <mat-icon color="primary" matTooltip="{{ column.hint }}" class="hint-icon">
                    {{ 'help_outline' }}</mat-icon
                  >
                }
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        <tr>
          @for (column of restrictionColumns; track column) {
            <td class="icon-row">
              <mat-icon
                [attr.data-id]="'columnRestriction_' + column.label"
                [class.green-icon]="isRestrictionAllowed(column.key)"
                color="{{ isRestrictionAllowed(column.key) ? '' : 'warn' }}">
                {{ isRestrictionAllowed(column.key) ? 'check_circle' : 'cancel' }}
              </mat-icon>
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
}
@if (!playerRestrictions) {
  <div class="background">
    <p data-id="noRestrictionsMessageText" class="header-second-paragraph">
      There are no journey restrictions applied for player's account
    </p>
  </div>
}
